// Lojas Triângulo — JS páginas internas (galeria PDP, quantity stepper). Sem libs.
(function(){
  'use strict';

  // Galeria PDP: troca imagem principal ao clicar no thumbnail
  document.querySelectorAll('[data-gallery]').forEach(function(gal){
    var main = gal.querySelector('#tri-pdp-main-img');
    var thumbs = gal.querySelectorAll('.tri-pdp__thumb');
    thumbs.forEach(function(t){
      t.addEventListener('click', function(){
        var src = t.getAttribute('data-src');
        if (src && main) main.src = src;
        thumbs.forEach(function(x){ x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  });

  // Quantity stepper
  document.querySelectorAll('[data-qty]').forEach(function(box){
    var input = box.querySelector('input[type=number]');
    box.querySelector('[data-dec]').addEventListener('click', function(){
      var v = Math.max(1, (parseInt(input.value,10)||1) - 1); input.value = v;
    });
    box.querySelector('[data-inc]').addEventListener('click', function(){
      var v = (parseInt(input.value,10)||1) + 1; input.value = v;
    });
  });
})();

// Páginas institucionais — comportamentos extras.
// FAQ usa <details> nativo. Só forçamos que uma única categoria fique aberta por vez.
(function(){
  'use strict';
  var lists = document.querySelectorAll('.tri-page-faq__list');
  lists.forEach(function(list){
    var items = list.querySelectorAll('.tri-page-faq__cat');
    items.forEach(function(item){
      item.addEventListener('toggle', function(){
        if(!item.open) return;
        items.forEach(function(other){
          if(other !== item && other.open) other.open = false;
        });
      });
    });
  });
})();